import { useSuspenseQueries } from '@tanstack/react-query';
import {
  featureFlagControllerAtMeQueryOptions,
  type FinalizeNewBusinessModuleRule,
} from 'korint-sdk';

/** Drops rules whose feature flag does not match their `when`; unflagged rules always apply. */
export function useFeatureFlaggedRules(
  rules: ReadonlyArray<FinalizeNewBusinessModuleRule>,
): FinalizeNewBusinessModuleRule[] {
  const flagIds = [
    ...new Set(rules.flatMap(rule => (rule.featureFlag ? [rule.featureFlag.id] : []))),
  ];

  // Suspend: reading an unresolved flag as false would drop a `when: true` rule and unblock buttons.
  const results = useSuspenseQueries({
    queries: flagIds.map(id => ({
      ...featureFlagControllerAtMeQueryOptions({ key: id }),
      // Flags derive from static config — they only change on deploy.
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
    })),
  });

  const enabledByFlagId = new Map(
    flagIds.map((id, index) => [id, results[index]?.data.enabled === true]),
  );

  return rules.filter(
    rule => !rule.featureFlag || enabledByFlagId.get(rule.featureFlag.id) === rule.featureFlag.when,
  );
}
